import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Prüft bei jedem Seitenwechsel, ob die Sitzung noch gültig ist. Ohne diese Prüfung bliebe eine
 *  bereits gerenderte, angemeldete Oberfläche sichtbar, solange keine API-Anfrage 401 liefert. */
export default function SessionWatch() {
  const { user, revalidate } = useAuth();
  const { pathname } = useLocation();
  useEffect(() => {
    if (user && pathname !== "/login") revalidate();
    // Absichtlich nur pathname als Auslöser: eine Prüfung je Navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return null;
}
